import { algo_1_privateTutor } from "../../solver/algo-new.ts";

const DRIVING_SPEED = 35 // mi/h
const DRIVING_SPEED_M_MIN = DRIVING_SPEED * 1609.34 / 60 // m/min

function sanitizeNegativeDistances(distances: number[][][])
{
	for (let cluster of distances)
	{
		for (let i = 0; i < cluster.length; i++)
		{
			for (let j = 0; j < cluster[i].length; j++)
			{
				if (cluster[i][j] < 0)
					cluster[i][j] = 0
			}
		}
	}
}
export function calcTimes(distances: number[][][]): number[][][]
{
	const times: number[][][] = []
	for (let cluster of distances)
	{
		let timesCluster: number[][] = []
		for (let i = 0; i < cluster.length; i++)
		{
			timesCluster.push([])
			for (let j = 0; j < cluster[i].length; j++)
			{
				timesCluster[i][j] = cluster[i][j] / DRIVING_SPEED_M_MIN
				if (timesCluster[i][j] < 0)
					throw new Error((console.error(cluster[i]), `negative time: ${times.length}, ${i}, ${j}`))
			}
		}
		times.push(timesCluster)
	}
	return times
}

export function runAlgoClusters(
	N: number,
	distances: number[][][],
	targetSum: number,
	dailyTimeLimit: number,
	timeSpentInNodes: number[][]
)
{
	sanitizeNegativeDistances(distances)

	let results = []
	let times = calcTimes(distances)
	for (let i = 0; i < distances.length; i++)
	{
		let res = algo_1_privateTutor(N, distances[i], times[i], targetSum, dailyTimeLimit, timeSpentInNodes[i])
		results.push(res)
	}

	return {
		results,
		times,
		distances,
	}
}
// export function streamline(pathsArr: number[][][])
// {
// 	let result = []
// 	while (pathsArr.length)
// 	{
// 		let rnd = Math.floor(Math.random() * pathsArr.length)
// 		let paths = pathsArr[rnd]
// 		if (!paths.length)
// 		{
// 			pathsArr.splice(rnd, 1)
// 			continue
// 		}
// 		let elem = paths.shift()
// 		if (!elem)
// 			continue

// 		result.push(elem)
// 	}
// 	return result
// }
